import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { IProductDetailById, IProductVariation } from 'src/models/ProductDetailById';
import './ExactMatch.scss';

interface IProps {
  exactProduct: IProductDetailById[];
  nonDigikeyProduct: IProductDetailById[];
  defaultExactProd: number;
  onExactProductClick: (
    searchQuery: string,
    id: number,
    unitPrice: number,
    pimVariantNumber: string,
    productVariations?: IProductVariation[]
  ) => void;
  unitPriceURL: number;
  partIdURL: number;
  pimNumberUrl: string;
}
const ExactMatch: React.FC<IProps> = ({
  exactProduct,
  nonDigikeyProduct,
  defaultExactProd,
  onExactProductClick,
  unitPriceURL,
  partIdURL,
  pimNumberUrl
}) => {
  // ! for language
  const { t } = useTranslation();
  const [selectedProduct, setSelectedProduct] = useState<number>(0);
  const [selectedProductPrice, setSelectedProductPrice] = useState<number>(0);
  const [unitPriceInURL, setUnitPriceURL] = useState<number>(0);
  const [partIdInURL, setPartIdInURL] = useState<number>(0);
  const [pimNumberInUrl, setPimNumberInUrl] = useState<string>('');
  const [selectedProductPimVariantNumber, setSelectedProductPimVariantNumber] =
    useState<string>('');

  useEffect(() => {
    setUnitPriceURL(unitPriceURL);
    setPartIdInURL(partIdURL);
    setPimNumberInUrl(pimNumberUrl);
  }, [unitPriceURL, partIdURL, pimNumberUrl]);

  useEffect(() => {
    if (
      defaultExactProd === 0 &&
      nonDigikeyProduct &&
      nonDigikeyProduct.length
    ) {
      setSelectedProduct(0);
      setSelectedProductPrice(0);
      setSelectedProductPimVariantNumber('');
    }
  }, [defaultExactProd, nonDigikeyProduct]);

  useEffect(() => {
    // Move non Digikey Part item to the front of Array
    if (
      exactProduct.length > 0 &&
      nonDigikeyProduct.length > 0 &&
      defaultExactProd === 0
    ) {
      const nonDigikeyProductId = nonDigikeyProduct[0].manufacturer?.id;
      exactProduct.sort((x, y) => {
        return x?.manufacturer.id === nonDigikeyProductId
          ? -1
          : y?.manufacturer.id === nonDigikeyProductId
          ? 1
          : 0;
      });
    }
  }, [exactProduct, nonDigikeyProduct, defaultExactProd]);

  const onClickManufactureNumber = (
    manufacturerProductNumber: string,
    manufacturerId: number,
    unitPrice: number,
    pimVariantNumber: string,
    productVariations?: IProductVariation[]
  ) => {
    if (manufacturerProductNumber && manufacturerId > 0) {
      onExactProductClick(
        manufacturerProductNumber,
        manufacturerId,
        unitPrice,
        pimVariantNumber,
        productVariations
      );
      setSelectedProduct(manufacturerId);
      setSelectedProductPrice(unitPrice);
      setSelectedProductPimVariantNumber(pimVariantNumber);
      setUnitPriceURL(0);
      setPartIdInURL(0);
    }
  };

  return (
    <div className="exact-match-products">
      <div className="exact-products">
        <div className="products">
          {exactProduct.map((product: IProductDetailById, index: number) => (
            <div
              key={index}
              className={`dk-card product ${
                (selectedProduct === product?.manufacturer?.id &&
                  selectedProductPrice === product?.unitPrice &&
                  selectedProductPimVariantNumber ===
                    product?.pimVariantNumber) ||
                (partIdInURL === product?.manufacturer?.id &&
                  unitPriceInURL === product?.unitPrice &&
                  pimNumberInUrl === product?.pimVariantNumber)
                  ? 'product-information-selected'
                  : ''
              }`}
              onClick={() =>
                onClickManufactureNumber(
                  product?.manufacturerProductNumber,
                  product?.manufacturer?.id,
                  product?.unitPrice,
                  product?.pimVariantNumber,
                  product?.productVariations
                )
              }
            >
              <div className="product-info">
                <div className="product-image-area">
                  <img
                    alt="product_image"
                    className="product-image"
                    src={
                      product?.primaryPhoto?.url
                        ? product?.primaryPhoto?.url
                        : 'https://media.digikey.com/Photos/NoPhoto/NoPhoto_sml.jpg'
                    }
                  />
                </div>
                <div className="product-information">
                  <div className="product-information__mnf-part-number">
                    {product?.manufacturerProductNumber}
                  </div>
                  <p className="product-information__vendor">
                    {product?.manufacturer?.name}
                  </p>
                  <p className="product-information__description">
                    {product?.description?.catalog}
                  </p>
                  <p className="product-information__price">
                    <span className="product-information__unit-price">
                      {t('xref-tbl-hd-unit-price')}
                    </span>
                    {product?.unitPrice !== 0
                      ? '$' + product?.unitPrice
                      : 'Call'}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ExactMatch;
